'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useConversationContext } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationHeaderInfo = /*#__PURE__*/React.forwardRef(function ConversationHeaderInfo(props, ref) {
  const {
      children,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = useConversationContext();
  const HeaderInfo = slots?.headerInfo ?? 'div';
  const headerInfoProps = useSlotProps({
    elementType: HeaderInfo,
    externalSlotProps: slotProps?.headerInfo,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(HeaderInfo, _extends({}, headerInfoProps, {
    children: children
  }));
});
if (process.env.NODE_ENV !== "production") ConversationHeaderInfo.displayName = "ConversationHeaderInfo";